<script>
import { notify } from '@/helpers/notify';

export default {
  name: 'Ariza',
  props: ['vericiId', 'counter'],
  data() {
    return {
      content: '',
      loading: false,
      submitted: false,
    };
  },
  watch: {
    counter() {
      this.content = '';
      this.loading = false;
      this.submitted = false;
    },
  },
  methods: {
    close() {
      this.$parent.$bvModal.hide('ariza-scoped');
    },

    handleSubmit() {
      this.submitted = true;

      if (!this.vericiId) {
        return notify.error('Verici seçilmedi');
      }

      if (!this.content || !this.content.trim()) {
        return notify.error('Arıza açıklaması giriniz');
      }

      this.loading = true;
      this.$http.post('/transmitter/faults/store', {
        content: this.content.trim(),
        verici_id: this.vericiId,
        type: 3,
      })
        .then((response) => {
          if (response.data.error) {
            return notify.error(response.data.message || 'Kayıt oluşturulamadı');
          }

          notify.success(response.data.message || 'Arıza kaydı oluşturuldu');
          this.$emit('created', response.data.content || {});
          this.close();

          this.$router.push({ name: 'hata-yonetimi' }).catch(() => {});
        })
        .catch(() => {
          notify.error('Arıza kaydı oluşturulurken hata oluştu');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <b-modal id="ariza-scoped" title="Arıza Aç" no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
      <div class="row mb-1">
        <div class="col-12">
          <div class="mb-3">
            <label for="content">Arıza Açıklaması</label>
            <textarea
              id="content"
              v-model="content"
              class="form-control"
              rows="4"
              placeholder="Arıza detayını yazın"
              :class="{ 'is-invalid': submitted && !content }"
            />
            <div class="invalid-feedback" v-if="submitted && !content">
              Açıklama zorunludur
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" type="button" @click="close()" :disabled="loading">Kapat</b-button>
        <b-button type="submit" variant="success" class="ms-1" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
          Oluştur
        </b-button>
      </div>
    </form>
  </b-modal>
</template>
